exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-5a73fdf6] {\n  width: 300px;\n}\n", ""]);

// exports
